import { LuDot } from "react-icons/lu";
import { formatFacadeElementDisplayId } from "../../../../common/userUniqueIdPrefixes";
import { CategoryType } from "../../../typesManager/constants/panelTypeEnums";
import { PanelView } from "./mapToViewable";
import "../../../../../assets/typesManagerStyles.css";
import eventBus from "../../../eventBus/eventDispatcher";

interface PanelSectionProps {
    panel: PanelView;
    selectedPanelId: string | null;
    categoryName: CategoryType;
}

const PanelSection = ({
    panel,
    selectedPanelId,
    categoryName,
}: PanelSectionProps) => {
    const isSelected = panel.id === selectedPanelId;

    const onPanelClick = () => {
        eventBus.dispatchEvent({
            type: "Dextall.TypesManager.UI.PanelSelected",
            payload: {
                panelId: panel.id,
                panelCategory: categoryName,
            },
        });
    };

    return (
        <div>
            <div
                key={panel.id}
                className="tm-panel-section"
            >
                <button
                    onClick={onPanelClick}
                    className={`tm-button tm-panel-section-user-unique-id ${isSelected ? "tm-selected" : ""}`}
                >
                    <LuDot className="tm-icon-dot" />
                    {formatFacadeElementDisplayId(panel, categoryName)}
                </button>
            </div>
        </div>
    );
};

export default PanelSection;
